module.exports = __webpack_public_path__ + "img/1497559830.05d9db97.jpg";